module.exports = __webpack_public_path__ + "img/bg_ranliao.62586a49.png";